import moment from 'moment'

export default {
    data() {
        return {
            mobileWidth: 426,
            listStatus: [
                {
                    id: -1,
                    text: window.__t('js.tat_ca'),
                    styleClass: 'badge badge-light',
                    sortOrder: -1,
                },
                {
                    id: 0,
                    text: window.__t('js.chua_hoan_thanh'),
                    styleClass: 'badge badge-light',
                    sortOrder: 0,
                },
                {
                    id: 1,
                    text: window.__t('js.hoan_thanh'),
                    styleClass: 'badge badge-secondary',
                    sortOrder: 1,
                },
                {
                    id: 2,
                    text: window.__t('js.da_huy'),
                    styleClass: 'badge badge-secondary',
                    sortOrder: 2,
                },

            ],
            precedenceEnum: [
                {},
                {},
                {},
                {
                    text: window.__t('js.dac_biet'),
                    value: 3,
                    star: 3
                },
                {
                    text: window.__t('js.binh_thuong'),
                    value: 4,
                    star: 2
                },
                {
                    text: window.__t('js.thap'),
                    value: 5,
                    star: 1
                }
            ],
            orderCustmerStatus: [
                {
                    id: 0,
                    text: window.__t('js.chua_hoan_thanh'),
                    styleClass: '',
                    sortOrder: 0
                },
                {
                    id: 1,
                    text: window.__t('js.hoan_thanh'),
                    styleClass: 'badge badge-light',
                    sortOrder: 1,
                },
                {
                    id: 2,
                    text: window.__t('js.da_huy'),
                    styleClass: 'badge badge-secondary',
                    sortOrder: 2,
                },
            ],
        }
    },
    methods: {
        formatDateTime(value) {
            if (value) {
                return moment(String(value)).format('HH:mm DD-MM-YYYY')
            }
        },
        formatDateTimeVN(value) {
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY HH:mm');
            }
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY')
            }
        },
        formatDateDB(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD')
            }
        },
        formatNumber(amount, decimalCount = 2, decimal = ".", thousands = ",") {
            try {
                decimalCount = Math.abs(decimalCount);
                decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                const negativeSign = amount < 0 ? "-" : "";

                let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                let j = (i.length > 3) ? i.length % 3 : 0;

                return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
            } catch (e) {
                console.log(e)
            }
        }
    },
}